import { useQueryUpdate } from '@shared/hooks'
import { Flex, Select, Space } from 'antd'
import { useTranslation } from 'react-i18next'

export const ConfigMFAFilters = () => {
  const { t } = useTranslation()
  const { params, updateQuery } = useQueryUpdate()

  const selectEnabledOptions = [
    { label: t('yes'), value: 'true' },
    { label: t('no'), value: 'false' }
  ]

  return (
    <Flex justify="space-between">
      <Space wrap>
        <Select
          placeholder={t('table.email_enabled')}
          options={selectEnabledOptions}
          allowClear
          className="select-min-width"
          value={params.mfaConfigEmailEnabled}
          onChange={(mfaConfigEmailEnabled) =>
            updateQuery({ mfaConfigEmailEnabled })
          }
        />

        <Select
          placeholder={t('table.enabled')}
          options={selectEnabledOptions}
          allowClear
          className="select-min-width"
          value={params.mfaConfigEnabled}
          onChange={(mfaConfigEnabled) => updateQuery({ mfaConfigEnabled })}
        />
      </Space>
    </Flex>
  )
}
